import { Stamp } from 'lucide-react';

import { EditorDePagina } from '@/components/pecas/EditorDePagina';
import { FormularioDoTimbrado } from '@/components/pecas/FormularioDoTimbrado';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PageHeader } from '@/components/ui/PageHeader';

const CONFIGURACOES = '/app/configuracoes';

/**
 * Tela dedicada do papel timbrado pessoal e da página das suas peças novas. Os dois
 * são os mesmos componentes da aba "Peças" do escritório (`FormularioDoTimbrado`,
 * `EditorDePagina`), aqui sobre o timbrado pessoal.
 */
function TimbradoPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        icon={<Stamp />}
        title="Papel timbrado"
        subtitle="Cabeçalho, rodapé, marca d’água e logo aplicados aos documentos gerados"
        backTo={{ label: 'Configurações', path: CONFIGURACOES }}
      />

      <Card className="max-w-4xl border bg-card">
        <CardContent className="pt-6">
          <FormularioDoTimbrado alvo="me" />
        </CardContent>
      </Card>

      <Card className="max-w-4xl border bg-card">
        <CardHeader>
          <CardTitle className="text-base">Página das peças novas</CardTitle>
        </CardHeader>
        <CardContent>
          <EditorDePagina alvo="me" />
        </CardContent>
      </Card>
    </div>
  );
}

export default TimbradoPage;
